import VlocTransactionDetails from 'features/lineOfCredit/screens/transactionDetails/VlocTransactionDetails';
import React from 'react';

export default function Page() {
  return <VlocTransactionDetails />;
}
